// extracted by css-extract-rspack-plugin
export default {"root":"root-OLUOCW","default":"default-KM0orO","invert":"invert-eBpYVX","inherit":"inherit-DBhENr","svg":"svg-QiJ0Iy"};